// src/utils/storage.js
// Safe localStorage access.
//
// iOS Safari throws on localStorage.setItem in two real-device situations that
// desktop Chrome (and its device-mode emulation) never hit:
//   • Private Browsing  → SecurityError on every setItem
//   • quota exceeded    → QuotaExceededError (Safari's quota is small, and the
//                         tickets cache written with ?withItems=1 can be large)
// A raw setItem inside the ticket-load flow would throw, abort fetchTickets before
// setTickets() runs, and leave the list blank — a real-mobile-only, role-independent
// failure. These wrappers make every storage access non-throwing so the data flow
// always completes; persistence just degrades to best-effort.

export const lsGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

// Returns true if the value was actually persisted, false if storage rejected it.
export const lsSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
};

export const lsRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    /* ignore */
  }
};

// Probe whether writes work at all right now (used by the gated debug panel).
// Returns { ok, error } without throwing.
export const lsProbe = () => {
  const probeKey = "__ls_probe__";
  try {
    localStorage.setItem(probeKey, "1");
    localStorage.removeItem(probeKey);
    return { ok: true, error: null };
  } catch (e) {
    return { ok: false, error: (e && e.name) || "error" };
  }
};
